import React, { useEffect } from 'react';
import QRCode from 'react-qr-code';
import { useDispatch, useSelector } from 'react-redux';

import {
  IUserSettingsState,
  loadOrInitUserSettings,
  shouldLoadUserSettings,
} from 'redux/reducers/userSettings';

import { RootState } from 'redux/rootReducer';
import { saveUserIsInterestedInAndroidApp } from 'redux/reducers/user/updateUsetIsInterestedInAndroidApp';

import useMedia from 'hooks/useMedia';
import { logToAmplitude } from 'helpers/logAmplitudeEvent';
import getMobileOS from 'helpers/getMobileOS';

import { ReactComponent as SelectedAppleMusic } from 'icons/playlistDsp/appleMusic-white.svg';
import { ReactComponent as AndroidIcon } from 'icons/android-icon.svg';
import { ReactComponent as CheckMarkIcon } from 'icons/icon-checkmark.svg';

import {
  Top,
  NotifierBannerWrapper,
  InnerWrapper,
  Section,
  Button,
} from './styles';

const NotifierBanner: React.FC = () => {
  const isMobileScreen = useMedia('(max-width: 45em)');
  const dispatch = useDispatch();
  const mobileOS = getMobileOS();

  useEffect(() => {
    if (dispatch(shouldLoadUserSettings())) {
      dispatch(loadOrInitUserSettings());
    }
  }, [dispatch]);

  const userSettings = useSelector(
    (state: RootState): IUserSettingsState => state.userSettings
  );
  const isInterested = userSettings?.data?.userIsInterestedInAndroidApp;

  const ON_linkUrl: any = useSelector(
    (state: RootState): any => state.consulEnvData?.data?.ON_linkUrl
  );
  const onButtonClick = (): void => {
    logToAmplitude('Interested in Android Notifier');
    dispatch(saveUserIsInterestedInAndroidApp(true));
  };
  return (
    <NotifierBannerWrapper>
      {isMobileScreen ? (
        mobileOS === 'iOS' ? (
          <>
            <Top>
              If you already have the Notifier app for your iPhone, continue to
              next screen.
            </Top>
            <InnerWrapper>
              If you don’t have the app, click to download now!
              <Button href={ON_linkUrl} width="100%">
                <SelectedAppleMusic /> Download Notifier App
              </Button>
            </InnerWrapper>
          </>
        ) : (
          <InnerWrapper>
            Click to register your interest.
            <Button
              onClick={onButtonClick}
              isInterested={isInterested}
              width="100%"
            >
              {isInterested ? (
                <>
                  <CheckMarkIcon /> You are registered!
                </>
              ) : (
                <>
                  <AndroidIcon /> Register Your Interest
                </>
              )}
            </Button>
          </InnerWrapper>
        )
      ) : (
        <>
          <Top>
            If you already have the Notifier app for your iPhone, continue to
            next screen.
          </Top>
          <Section>
            <InnerWrapper>
              If you don’t have the app, scan QR code with your iPhone to
              download.
              <QRCode value={ON_linkUrl || ''} size={84} />
            </InnerWrapper>
            <InnerWrapper>
              If you have an Android phone, app is not available yet! Click to
              register your interest.
              <Button onClick={onButtonClick} isInterested={isInterested}>
                {isInterested ? (
                  <>
                    <CheckMarkIcon /> You are registered!
                  </>
                ) : (
                  <>
                    <AndroidIcon /> Register Your Interest
                  </>
                )}
              </Button>
            </InnerWrapper>
          </Section>
        </>
      )}
    </NotifierBannerWrapper>
  );
};

export default NotifierBanner;
